export default function () {
  return {
    visible: false,
    timeout: 0,
    kind: '',
    messages: '',
    icon: '',
    pageSpecific: false,
    flash: {
      visible: false,
      timeout: 0,
      kind: '',
      messages: '',
      icon: '',
      pageSpecific: false
    },
    cookie_consent: {
      visible: false,
      timeout: 0,
      kind: '',
      messages: '',
      icon: '',
      pageSpecific: false
    }
  }
}
